module.exports = __webpack_public_path__ + "img/diverse-workforces-mobile@3x.d22e3126.webp";